// extracted by mini-css-extract-plugin
export var changeIcon = "_54-4";
export var container = "_54-0";
export var divider = "_54-7";
export var externalLinkIcon = "_54-1";
export var green = "_54-5";
export var helpCircleIcon = "_54-3";
export var iconButton = "_54-2";
export var red = "_54-6";